import React, {useContext, useEffect, useState} from 'react';
import {Breadcrumb} from "../components/Breadcrumb";
import {
    Box, Button, Checkbox,
    Container,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Typography,
    Hidden, Dialog, Backdrop, DialogTitle, CircularProgress
} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {Sidebar} from "../components/sidebar";
import {SelectableCardHelp} from "../components/helpform/selectableCardHelp";
import {helpFormReasons} from "../configs/complianceReasons";
import {IHelpFormReasons} from "../interfaces/assistanceContext";
import {DropZoneComplaint} from "../components/complaints/dropZoneComplaint";
import {getCurrentWebsite, getPrivacyLink} from "../utils/helpers";
import {AppContext} from "../utils/appContext";
import {UserDataHelp} from '../components/helpform/userDataHelp';
import axios, {AxiosRequestConfig} from "axios";
import {toast} from "react-toastify";
import {makeStyles} from "tss-react/mui";
import {DropZoneHelpForm} from "../components/helpform/dropZoneHelpForm";
import Handshake from "../assets/img/handshake.svg";
import {SendComplaintModal} from "../components/complaints/sendComplaintModal";
import {SendHelpFormModal} from "../components/helpform/sendHelpFormModal";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const HelpForm = () => {
    const appContext = useContext(AppContext);
    const {t} = useTranslation();
    const [backdropOpen, setBackdropOpen] = useState(false);

    const useStyles = makeStyles()(() => {
        return {
            overlineTitle: {
                textTransform: 'uppercase',
                fontSize: 18,
                fontWeight: 800,
                borderBottom: '4px solid #FFEB34',
                display: 'inline',
            },
            tabContent: {
                '& .MuiBox-root': {
                    padding: '24px 0'
                }
            },
            submitBtn: {
                borderRadius: '0!important',
                backgroundColor: '#FFEE00',
                color: '#000!important',
                fontSize: '22px!important',
                width: '60%!important',
                fontFamily: 'Jost, sans-serif!important',
                '&:hover': {
                    backgroundColor: '#FFEE00',
                }
            },
            backdrop: {
                zIndex: 999,
                color: '#fff',
            },
            header: {
                '& i': {
                    marginLeft: 20,
                    cursor: 'pointer',
                    position: 'absolute',
                    top: 30,
                    right: 30,
                    background: '#FFEB34',
                    boxShadow: '0px 3px 6px #FFEB34',
                    borderRadius: '50%',
                    color: 'black',
                    padding: 4
                }
            },
            iconContainer: {
                padding: '13px 21px',
                backgroundColor: '#FFEB34',
                borderRadius: '50%',
                '& img': {
                    paddingTop: 20,
                    filter: 'brightness(0)'
                }
            }
        }
    });

    const {classes} = useStyles();

    const [disable, setDisable] = useState(false);
    const [flagPrivacy, setFlagPrivacy] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);

    const property = [
        {
            key: 'NG',
            title: 'Norcenni Girasole Village',
            pos: 'hu'
        },
        {
            key: 'PA',
            title: 'Park Albatros Village',
            pos: 'hu'
        },
        {
            key: 'FA',
            title: 'Fabulous Village',
            pos: 'hu'
        },
        {
            key: 'AM',
            title: 'Altomincio Family Park',
            pos: 'hu'
        },
        {
            key: 'MS',
            title: 'Montescudaio Village',
            pos: 'hu'
        },
        {
            key: 'IP',
            title: 'I Pini Family Park',
            pos: 'hu'
        },
        {
            key: 'BK',
            title: 'Birkelt Village',
            pos: 'hu'
        },
        {
            key: 'JO',
            title: 'Venezia Camping in Town',
            pos: 'hu'
        },
        {
            key: 'CF',
            title: 'Firenze Camping in Town',
            pos: 'hu'
        },
        {
            key: 'RO',
            title: 'Roma Camping in Town',
            pos: 'hu'
        },
        {
            key: 'UL',
            title: 'Union Lido',
            pos: 'hu'
        },
        {
            key: 'PT',
            title: 'Pra\' delle torri',
            pos: 'hu'
        },
        {
            key: 'BI',
            title: 'Bella Italia',
            pos: 'hu'
        },
        {
            key: 'CI',
            title: 'Cisano',
            pos: 'hu'
        },
        {
            key: 'CE',
            title: 'Firenze Certosa Camping',
            pos: 'ce'
        },
    ];

    const getTitleByWebsite = (value: any): any => {
        return appContext.website !== 'HU' ? property.find(item => item.key === value)?.title : property.find(item => item.key === value && item.pos === 'hu')?.title ;
    }

    const handleChangeArgument = (event: React.ChangeEvent<HTMLInputElement>) => {
        appContext.helpForm.Argument = event.target.value;
        appContext.setHelpForm({...appContext.helpForm});
    };

    useEffect(() => {
        if(appContext.helpReason === 1){
            appContext.helpForm.Argument = 'Pagamento';
            appContext.setHelpForm({...appContext.helpForm});
        } else {
            appContext.helpForm.Argument = '';
            appContext.setHelpForm({...appContext.helpForm});
        }
    }, [appContext.helpReason])


    const endPoint = appContext.website === 'HU' ? '/api/contact' : '/!/complaints/contact';

    const handleSubmit = async (event: any) => {

        event.preventDefault();
        setDisable(true);
        setBackdropOpen(true);

        console.log(appContext.helpForm.Property)

        if(appContext.helpForm.GuestFirstname !== '' && appContext.helpForm.GuestName !== '' && appContext.helpForm.Email !== '' && appContext.helpForm.Note !== '' && (appContext.complaint.Property !== undefined || getCurrentWebsite() !== 'HU') && flagPrivacy){

            const recaptchaToken = await appContext.getTokenRecaptcha();

            const config: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': window.document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Recaptcha': recaptchaToken
                }
            };

            const formData = new FormData();
            formData.append('email', appContext.helpForm.Email);
            formData.append('name', appContext.helpForm.GuestFirstname + ' ' + appContext.helpForm.GuestName);
            formData.append('00N0900000Jru9O', appContext.helpForm.ReservationNumber);

            if (appContext.helpForm.GuestArrival) {
                formData.append('00N0E00000Isxtw', appContext.helpForm.GuestArrival.format('YYYY-MM-DD'));
            }

            if (appContext.helpForm.GuestDeparture) {
                formData.append('00N0E00000Isxtx', appContext.helpForm.GuestDeparture.format('YYYY-MM-DD'));
            }

            formData.append('description', appContext.helpForm.Note);
            formData.append('reason', helpFormReasons[appContext.helpReason].value);
            formData.append('00N0900000BWKK0', appContext.helpForm.Argument);
            formData.append('00N0900000BWKJz', getCurrentWebsite() === 'HU' ? getTitleByWebsite(appContext.helpForm.Property) : getTitleByWebsite(getCurrentWebsite()));

            appContext.helpForm.Attachment.forEach( (file: File) => {
                formData.append('Attachment[]', file, file.name);
            });

            axios.post(endPoint, formData, config)
                .then(function (response) {
                    console.log(response);
                    setModalOpen(true);

                    appContext.setHelpForm({...appContext.helpForm,
                        GuestFirstname: '',
                        GuestName: '',
                        Email: '',
                        ReservationNumber: '',
                        Note: '',
                        Attachment: [],
                        Reasons: '',
                        GuestArrival: null,
                        GuestDeparture: null,
                        Property: ''
                    });
                    setFlagPrivacy(false);
                    setDisable(false);
                    setBackdropOpen(false);
                })
                .catch(function (error) {
                    toast.error(t('error_sending_complaints'));
                    setDisable(false);
                    setBackdropOpen(false);
                });
        } else {
            if(appContext.helpForm.GuestFirstname === ''){
                toast.error(t('alert_name'));
            } else if(appContext.helpForm.GuestName === '') {
                toast.error(t('alert_surname'));
            } else if(appContext.helpForm.Email === '') {
                toast.error(t('alert_email'));
            } else if(appContext.helpForm.Note === '') {
                toast.error(t('alert_note'));
            } else if(!flagPrivacy) {
                toast.error(t('alert_privacy'));
            } else if(appContext.complaint.Property === '' && getCurrentWebsite() === 'HU') {
                toast.error(t('alert_property'));
            }
            setDisable(false);
            setBackdropOpen(false);
        }
    }

    const SendModal = () => (
        <Dialog
            style={{overflow: 'scroll', zIndex: 999999, margin: 'auto'}}
            open={isModalOpen}
            onClose={() => setModalOpen(false)}
            closeAfterTransition
            maxWidth={'lg'}
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500
            }}
        >
            <DialogTitle onClick={() => setModalOpen(false)}>
                <Grid container
                      direction="row"
                      justify="center"
                      alignItems="flex-start"
                      className={classes.header}
                >
                    <Grid item>
                        <Box p={4}>
                            <Box>
                                <div className={classes.iconContainer}>
                                    <img src={Handshake} />
                                </div>
                                <i className="las la-times"></i>
                            </Box>

                        </Box>
                    </Grid>
                </Grid>
            </DialogTitle>
            <SendHelpFormModal />
        </Dialog>
    );


    // @ts-ignore
    return (
        <Container maxWidth="lg">
            <Box mt={5}>

            </Box>

            <SendModal />

            <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="flex-start"
            >
                <Grid item lg={3} xs={11}>
                    <Breadcrumb text={t('assistenza')} />
                    <Box mb={3}>
                        <Sidebar text={t('assistenza')} />
                    </Box>
                </Grid>

                <Grid item xs={11} lg={9}>

                    <Box mb={5}>
                        <Hidden smDown>
                            <Box mb={4}>
                                <Typography component={'h6'} variant={'h6'} className={classes.overlineTitle}>{t('assistenza')}</Typography>
                            </Box>
                        </Hidden>
                        <Typography component={'h1'} variant={'h1'}>{t('Hai bisogno di aiuto?')}</Typography>
                        <Box mt={5}>
                            <Typography component={'h5'} variant={'h5'}>{t('Seleziona il motivo della richiesta')}</Typography>
                        </Box>
                    </Box>

                    <SelectableCardHelp />

                    <Box className={classes.tabContent}>

                        {/*{
                            helpFormReasons.map((reason: IHelpFormReasons) => {
                                reason.title === 'Payment' && (
                                    <Box mt={5}>
                                        <Typography component={'h5'} variant={'h5'}>{t('Specifica il tipo di problema')}</Typography>
                                    </Box>
                                )
                            })
                        }*/}


                        {
                            appContext.helpReason !== 1 && (
                                <Box mt={5}>
                                    <Typography component={'h5'} variant={'h5'}>{t('Specifica il tipo di problema')}</Typography>
                                </Box>
                            )
                        }


                        {
                            helpFormReasons.map((reason: IHelpFormReasons, index: number) => (
                                <TabPanel value={appContext.helpReason} index={index} key={index}>
                                    {
                                        appContext.helpReason !== 1 && (
                                            <FormControl component="fieldset">
                                                <RadioGroup aria-label="gender" name={reason.title} value={appContext.helpForm.Argument} onChange={handleChangeArgument} style={{flexDirection:'row'}}>
                                                    {
                                                        reason.radioList.map((list: any, indexList: number) => (
                                                            <FormControlLabel key={indexList} value={list.title} control={<Radio />} label={t(list.title).toString()} />
                                                        ))
                                                    }
                                                </RadioGroup>
                                            </FormControl>
                                        )
                                    }

                                    <form action="" onSubmit={handleSubmit} method={'post'} noValidate>
                                        {
                                            appContext.helpForm.Argument && (
                                                <>
                                                    <UserDataHelp argument={appContext.helpForm.Argument} />
                                                    <DropZoneHelpForm/>

                                                    <Box mt={4} pb={0}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    name="checkedB"
                                                                    color="primary"
                                                                    required={true}
                                                                    checked={flagPrivacy}
                                                                    onChange={() => {
                                                                        setFlagPrivacy(!flagPrivacy)
                                                                    }}
                                                                />
                                                            }
                                                            label={
                                                                <div>
                                                                    {t('accetto_privacy')} <a href={getPrivacyLink()} target="_blank" style={{color: '#000!important'}}>Privacy Policy</a>
                                                                </div>
                                                            }
                                                        />
                                                    </Box>

                                                    <Box p={0} style={{ padding: '0!important' }}>
                                                        <Button type={"submit"} variant="contained" color="primary"
                                                                style={{display: 'block', width:'50%!important'}} disabled={disable} className={classes.submitBtn}>
                                                            <Typography component="p" variant="button">{t('invia richiesta')}</Typography>
                                                        </Button>
                                                    </Box>

                                                </>
                                            )
                                        }
                                    </form>

                                </TabPanel>
                            ))
                        }
                    </Box>

                </Grid>
            </Grid>
            <Backdrop className={classes.backdrop} open={backdropOpen}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Container>
    )
}

export default HelpForm;
